<div class="card card-w-title">
  <h1>I documenti la cui classifica è in scadenza</h1>

  <div class="toolbar">
    <div class="view">
      <p-selectButton [options]="states" (onChange)="changeViewState($event)" [(ngModel)]="selectedState">
      </p-selectButton>
    </div>
    <div class="right">
      <p-autoComplete [suggestions]="selectProtocollo" [autofocus]="true" [dropdown]="true" dropdownMode="blank"
        (onKeyUp)="filterKeyUp($event)" (onFocus)="focusAutocomplete($event)"
        (completeMethod)="protocolloSearch($event)" (onSelect)="filterTableResults()" appendTo="body"
        [autoHighlight]="true" [size]="20" [forceSelection]="true" [(ngModel)]="selectedProtocol">
      </p-autoComplete>
    </div>
  </div>


  <div class="content">
    <app-documenti-list [data]="searchResponse" [activeColumns]="columns" [showDeclassificaButton]="true"
      [showDistruggiButton]="true" [enableDateExpirationCss]="true" [allowPosizioneHierarchy]="false"
      (declassify)="onShowDeclassifica($event)" (destroy)="onShowDistruzione($event)"
      (updateRequestAndSearch)="updateRequestAndSearch($event)">
    </app-documenti-list>
  </div>

</div>

<app-declassifica-dialog [visible]="showDeclassificaDialog" [documentId]="currDocumentId"
  [qualifica]="qualificaSelected ?? 0" (hide)="onHideDeclassifica()" (done)="search()"
  [classifica]="classificaSelected ?? 0"
  ></app-declassifica-dialog>

<app-distruzione-dialog [visible]="showDistruzioneDialog" [documentId]="currDocumentId"
  [allegati]="currDocumentoDistruzioneAllegati" (hide)="onHideDistruzione()" (done)="search()"></app-distruzione-dialog>